export const CONTACT_INFO_TITLE = '5. Contact Information'
export const CONTACT_INFO_SUBHEAD = 'Let us know how to reach you.'
